// removed by extract-text-webpack-plugin
module.exports = {"block":"BrandBadgeScreen_block_2v9Ar","blockContent":"BrandBadgeScreen_blockContent_zqR52","card":"BrandBadgeScreen_card_3D_FJ"};